"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyLinkWidgetRenderer = void 0;
class CopyLinkWidgetRendererImpl {
    renderHTML(params) {
        return this.renderContainer(params.shortLink);
    }
    renderContainer(shortLink) {
        return `<a href="${shortLink}" target="_blank">${shortLink}</a>`;
    }
}
exports.CopyLinkWidgetRenderer = new CopyLinkWidgetRendererImpl();
